<template>
  <div class="widget-form-container">
    <el-form :label-position="data.labelPosition || 'left'"
            :label-width="data.labelWidth ? `${data.labelWidth}px` : '100px' "
            :label-suffix="data.labelSuffix"
            :model="form"
            ref="widgetForm">
      <el-row :gutter="data.gutter">
        <draggable class="widget-form-list"
                  :list="data.column"
                  :group="{ name: 'form' }"
                  ghost-class="ghost"
                  :animation="300"
                  @add="handleWidgetAdd"
                  @end="$emit('change')">
          <template v-for="(column, index) in data.column">
            <div class="widget-form-table"
                v-if="column.type == 'dynamic'"
                :key="index"
                :class="{ active: selectWidget.prop == column.prop }"
                @click="handleSelectWidget(index)">
              <!-- todo update -->
              <widget-form-table :data="data"
                                :column="column"
                                :index="index"
                                :select.sync="selectWidget"
                                @change="$emit('change')"></widget-form-table>
            </div>
            <div class="widget-form-group"
                v-else-if="column.type == 'group'"
                :key="index"
                :class="{ active: selectWidget.prop == column.prop }"
                @click="handleSelectWidget(index)">
              <widget-form-group :data="data"
                                :column="column"
                                :index="index"
                                :select.sync="selectWidget"
                                @change="$emit('change')">
              </widget-form-group>
            </div>
            <el-col v-else
                    :key="index"
                    :md="column.span || 12"
                    :xs="24"
                    :offset="column.offset || 0"
                    :class="{colLastChild: index === data.column.length -1 && mode === 2}">
              <el-form-item
                            class="widget-form-item"
                            :label="column.label"
                            :prop="column.prop"
                            :class="{ active: selectWidget.prop == column.prop, 'required': column.required }"
                            @click.native="handleSelectWidget(index)">
                            <!-- todo update WidgetFormItem code -->
                <component :is="getComponent(column.type, column.component)"
                           :id="column.prop"
                           :action="column.action"
                           :append="column.append"
                           :accordion="column.accordion"
                           :typeslot="column.typeslot"
                           :appendClick="column.appendClick"
                           :border="column.border"
                           :change="column.change"
                           :checked="column.checked"
                           :clearable="column.clearable"
                           :changeOnSelect="column.changeOnSelect"
                           :click="column.click"
                           :onRemove="column.onRemove"
                           :showWordLimit="column.showWordLimit"
                           :column="column"
                           :colors="column.colors"
                           :canvasOption="column.canvasOption"
                           :controls-position="column.controlsPosition"
                           :dataType="column.dataType"
                           :defaultExpandAll="column.defaultExpandAll"
                           :defaultTime="column.defaultTime"
                           :dic="column.dicData"
                           :dicUrl="column.dicUrl"
                           :dicMethod="column.dicMethod"
                           :dicQuery="column.dicQuery"
                           :disabled="column.disabled"
                           :drag="column.drag"
                           :endPlaceholder="column.endPlaceholder"
                           :expand-trigger="column.expandTrigger"
                           :filter="column.filter"
                           :blur="column.blur"
                           :focus="column.focus"
                           :tpyeformat="column.tpyeformat"
                           :filesize="column.filesize"
                           :filterable="column.filterable"
                           :format="column.format"
                           :formatTooltip="column.formatTooltip"
                           :iconClasses="column.iconClasses"
                           :label="column.label"
                           :limit="column.limit"
                           :listType="column.listType"
                           :loadText="column.loadText"
                           :min="column.min"
                           :max="column.max"
                           :minlength="column.minlength"
                           :maxlength="column.maxlength"
                           :minRows="column.minRows"
                           :maxRows="column.maxRows"
                           :multiple="column.multiple"
                           :nodeClick="column.nodeClick"
                           :options="column.options"
                           :oss="column.oss"
                           :parent="column.parent"
                           :pickerOptions="column.pickerOptions"
                           :placeholder="getPlaceholder(column)"
                           :precision="column.precision"
                           :prefixIcon="column.prefixIcon"
                           :prepend="column.prepend"
                           :prependClick="column.prependClick"
                           :prop="column.prop"
                           :ref="column.prop"
                           :props="column.props"
                           :propsHttp="column.propsHttp"
                           :range="column.range"
                           :iconList="column.iconList"
                           :readonly="column.readonly"
                           :checkStrictly="column.checkStrictly"
                           :separator="column.separator"
                           :showFileList="column.showFileList"
                           :showInput="column.showInput"
                           :showStops="column.showStops"
                           :showAllLevels="column.showAllLevels"
                           :showText="column.showText"
                           :size="column.size || 'small'"
                           :startPlaceholder="column.startPlaceholder"
                           :step="column.step"
                           :suffixIcon="column.suffixIcon"
                           :texts="column.texts"
                           :tip="column.tip"
                           :type="column.type"
                           :accept="column.accept"
                           :tags="column.tags"
                           :value-format="column.valueFormat"
                           :valueDefault="column.valueDefault"
                           :voidIconClass="column.voidIconClass"
                           :remote="column.remote"
                           :autocomplete="column.autocomplete"
                           v-model="form[column.prop]"
                           :allow-create="column.allowCreate"
                           :default-first-option="column.defaultFirstOption"
                           :headers="column.headers"></component>
                <el-button title="删除"
                          @click.stop="handleWidgetDelete(index)"
                          class="widget-action-delete"
                          v-if="selectWidget.prop == column.prop"
                          circle
                          plain
                          type="danger">
                  <i class="iconfont icon-delete"></i>
                </el-button>
                <el-button title="复制"
                           @click.stop="handleWidgetClone(index)"
                           class="widget-action-clone"
                           v-if="selectWidget.prop == column.prop"
                           circle
                           plain
                           type="primary">
                  <i class="iconfont icon-copy"></i>
                </el-button>
              </el-form-item>

            </el-col>
          </template>
        </draggable>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import Draggable from 'vuedraggable'
import { getToken } from '@/framework/util/auth'
import WidgetFormTable from './WidgetFormTable'
import WidgetFormGroup from './WidgetFormGroup'

// import AvueDivider from '@/workFlow/formComponent/component/divider/divider.vue'

export default {
  name: 'WidgetForm',
  components: { Draggable, WidgetFormTable, WidgetFormGroup },
  props: ['data', 'select', 'mode'],
  data() {
    return {
      selectWidget: this.select,
      form: {}
    }
  },
  methods: {
    getComponent(type, component) {
      let KEY_COMPONENT_NAME = 'avue-'
      let result = 'input'
      if (!this.validatenull(component)) {
        return component
      } else if (type === 'select') {
        result = 'select'
      } else if (type === 'radio') {
        result = 'radio'
      } else if (type === 'checkbox') {
        result = 'checkbox'
      } else if (['time', 'timerange'].includes(type)) {
        result = 'time'
      } else if (
        [
          'dates',
          'date',
          'datetime',
          'datetimerange',
          'daterange',
          'week',
          'month',
          'year'
        ].includes(type)
      ) {
        result = 'date'
      } else if (type === 'cascader') {
        result = 'cascader'
      } else if (type === 'number') {
        result = 'input-number'
      } else if (type === 'password') {
        result = 'input'
      } else if (type === 'switch') {
        result = 'switch'
      } else if (type === 'rate') {
        result = 'rate'
      } else if (type === 'upload') {
        result = 'upload'
      } else if (type === 'slider') {
        result = 'slider'
      } else if (type === 'dynamic') {
        result = 'dynamic'
      } else if (type === 'icon-select') {
        result = 'icon-select'
      } else if (type === 'color') {
        result = 'color'
      } else if (type === 'divider') {
        result = 'divider'
      } else if (type === 'general') {
        result = 'input'
      }

      return KEY_COMPONENT_NAME + result
    },
    getPlaceholder(column) {
      const label = column.label
      if (['select', 'checkbox', 'radio', 'tree', 'color', 'date', 'time'].includes(column.type)) {
        return `请选择${label}`
      } else {
        return `请输入${label}`
      }
    },
    handleSelectWidget(index) {
      this.selectWidget = this.data.column[index]
    },
    handleWidgetAdd(evt) {
      const newIndex = evt.newIndex
      const data = this.deepClone(this.data.column[newIndex])
      if (data.type === 'dynamic') { // 动态表单中添加子表单时默认添加的内容
        // data.children.column.push({
        //   'type': 'input',
        //   'label': '子表主键',
        //   'span': 24,
        //   'display': false,
        //   'hide': true,
        //   'prop': 'id'
        // },
        // {
        //   'type': 'input',
        //   'label': '主表关联字段',
        //   'span': 24,
        //   'display': false,
        //   'hide': true,
        //   'prop': 'pid',
        //   'readonly': false
        // }
        // )
      } else if (data.type === 'upload') {
        data.headers = Object.assign(data.headers, getToken())
      }
      if (!data.prop) data.prop = Date.now() + '_' + Math.ceil(Math.random() * 99999)
      delete data.icon
      delete data.subfield
      this.$set(this.data.column, newIndex, { ...data })
      this.handleSelectWidget(newIndex)
    },
    handleWidgetClear(index) {
      this.data.column[index].children.column = []
      this.selectWidget = this.data.column[index]
    },
    handleWidgetDelete(index) {
      if (this.data.column.length - 1 === index) {
        if (index === 0) this.selectWidget = {}
        else this.handleSelectWidget(index - 1)
      } else this.handleSelectWidget(index + 1)

      this.$nextTick(() => {
        this.data.column.splice(index, 1)
      })
    },
    handleWidgetClone(index) {
      let cloneData = this.deepClone(this.data.column[index])
      cloneData.prop = Date.now() + '_' + Math.ceil(Math.random() * 99999)
      this.data.column.splice(index, 0, cloneData)
      this.$nextTick(() => {
        this.handleSelectWidget(index + 1)
      })
    },
    handleWidgetCloneTable(index) {
      let cloneData = this.deepClone(this.data.column[index])
      cloneData.prop = Date.now() + '_' + Math.ceil(Math.random() * 99999)
      cloneData.children.column.forEach(t => {
        t.prop = Date.now() + '_' + Math.ceil(Math.random() * 99999)
      })
      this.data.column.splice(index, 0, cloneData)
      this.$nextTick(() => {
        this.handleSelectWidget(index + 1)
      })
    },
    handleWidgetTableAdd(evt, column) {
      let newIndex = evt.newIndex
      const item = evt.item

      if (newIndex == 1 && newIndex > column.children.column.length - 1) newIndex = 0
      if (['子表单', '富文本', '坐标拾取器'].includes(item.textContent)) {
        column.children.column.splice(newIndex, 1)
        return
      }

      const data = this.deepClone(column.children.column[newIndex])
      if (!data.prop) data.prop = Date.now() + '_' + Math.ceil(Math.random() * 99999)
      data.subfield = true
      delete data.icon
      this.$set(column.children.column, newIndex, { ...data })
      this.selectWidget = column.children.column[newIndex]
    },
    handleWidgetTableSelect(data) {
      this.selectWidget = data
    },
    handleWidgetTableClone(column, item) {
      const data = this.deepClone(item)
      data.prop = Date.now() + '_' + Math.ceil(Math.random() * 99999)
      this.$set(column.children.column, column.children.column.length, { ...data })
      this.$nextTick(() => {
        this.selectWidget = column.children.column[column.children.column.length - 1]
      })
    },
    handleWidgetTableDelete(column, index) {
      if (column.children.column.length - 1 == index) {
        if (index == 0) this.selectWidget = column
        else this.selectWidget = column.children.column[index - 1]
      } else this.selectWidget = column.children.column[index + 1]
      this.$nextTick(() => {
        column.children.column.splice(index, 1)
      })
    }
  },
  watch: {
    select(val) {
      this.selectWidget = val
    },
    selectWidget: {
      handler(val) {
        this.$emit('update:select', val)
      },
      deep: true
    }
  }
}
</script>
